// Simple base64 encoding utility
export function btoa(str: string): string {
  return window.btoa(str);
}

export function atob(str: string): string {
  return window.atob(str);
}